import React, { useEffect } from 'react';
import { Grid } from '@material-ui/core';

import yup from '../../utility/yup';
import { FormUrlInput, FormInput } from '../../components';
import SavedSearchService, { SavedSearchPages } from '../../services/SavedSearchService';

export const infoSchema = {
  title: yup.string().required().trim(),
  last_edit_age_string: yup.string(),
  notification_email_addresses: yup.string().emailList(),
  'options.demo_url': yup.string().url(),
};

type Props = {
  active: boolean;
};

const TabInfo = ({ active }: Props) => {
  const inputRef: React.MutableRefObject<HTMLInputElement | null | undefined> = React.useRef();

  useEffect(() => {
    if (active && inputRef.current) {
      inputRef.current.focus();
    }
  }, [active]);

  return (
    <Grid container spacing={4}>
      <Grid item xs={12}>
        <FormInput
          label="Title"
          name="title"
          autoFocus={active}
          inputRef={inputRef}
          getValueAfterInit={() => SavedSearchService.getValue(SavedSearchPages.VideoMenus)}
        />
      </Grid>
      <Grid item xs={6}>
        <FormInput
          label="Organization"
          name="ref.organization.common_name"
          disabled
          spellCheck
        />
      </Grid>
      <Grid item xs={6}>
        <FormInput
          label="User"
          name="ref.user.full_name_first_last"
          disabled
          spellCheck
        />
      </Grid>
      <Grid item xs={12}>
        <FormInput
          label="Last update"
          name="ref.updated_age"
          disabled
          spellCheck
        />
      </Grid>
      <Grid item xs={12}>
        <FormInput
          label="Notification email addresses"
          name="notification_email_addresses"
          type="textarea"
          spellCheck
        />
      </Grid>
      <Grid item xs={12}>
        <FormUrlInput
          label="Preview URL"
          name="ref.preview_url"
          disabled
          spellCheck
        />
      </Grid>
      <Grid item xs={12}>
        <FormUrlInput
          label="Deployment URL"
          name="options.demo_url"
          spellCheck
        />
      </Grid>
    </Grid>
  );
};

export default TabInfo;
